import {CleanupJobs, Dispatchable, Dispatcher, type CleanupJob} from "../stem-core/base/Dispatcher";

// Anything that announces its own changes: the stores in blinkpay/State, mostly
interface ChangeDispatcher {
    addChangeListener(callback: () => void): CleanupJob;
}


// TODO @flow merge with the autoredraw stuff, and maybe add a function enqueueRedraw(uiElement) that is global
export class AsyncAggregateDispatcher extends Dispatcher {
    declare cleanupJobs?: CleanupJobs;
    declare willDispatchEvent?: boolean;
    constructor({listener, changeDispatchers}: {listener?: () => void; changeDispatchers?: ChangeDispatcher[]}) {
        super();
        this.cleanupJobs = new CleanupJobs();
        this.willDispatchEvent = false;
        for (const changeDispatcher of (changeDispatchers || [])) {
            this.attachChangeDispatcher(changeDispatcher);
        }
        if (listener) {
            this.addListener(listener);
        }
    }

    attachChangeDispatcher(dispatcher: ChangeDispatcher) {
        const cleanupJob = dispatcher.addChangeListener(() => this.dispatch());
        this.cleanupJobs.add(cleanupJob);
    }

    attachDispatcher(dispatcher: Dispatchable, channel: string) {
        const cleanupJob = dispatcher.addListener(channel, () => this.dispatch());
        this.cleanupJobs.add(cleanupJob);
    }

    dispatch() {
        if (this.willDispatchEvent) {
            return;
        }
        this.willDispatchEvent = true;
        queueMicrotask(() => {
            super.dispatch();
            this.willDispatchEvent = false;
        });
    }

    cleanup() {
        this.removeAllListeners();
        this.cleanupJobs.cleanup();
    }
}
